import data from './attrs/data'

export default {
    name: 'Posts',
    data
}
